/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_CustomInputs */

const en_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const ar_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مخصص`)
};

const bn_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const de_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const es_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const fr_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const pt_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const zh_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const tr_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const ru_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

const pl_svtag_custom = /** @type {(inputs: Svtag_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CUSTOM`)
};

/**
* | output |
* | --- |
* | "#CUSTOM" |
*
* @param {Svtag_CustomInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_custom = /** @type {((inputs?: Svtag_CustomInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_CustomInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_custom(inputs)
	if (locale === "bn") return bn_svtag_custom(inputs)
	if (locale === "de") return de_svtag_custom(inputs)
	if (locale === "es") return es_svtag_custom(inputs)
	if (locale === "fr") return fr_svtag_custom(inputs)
	if (locale === "pt") return pt_svtag_custom(inputs)
	if (locale === "zh") return zh_svtag_custom(inputs)
	if (locale === "tr") return tr_svtag_custom(inputs)
	if (locale === "ru") return ru_svtag_custom(inputs)
	if (locale === "pl") return pl_svtag_custom(inputs)
	return en_svtag_custom(inputs)
});